import React from "react";

export const useOrdersControllers = () => {
  const initialFilter = {
    search: "",
    order_type: "",
    status: "",
  };

  const [filter, setFilter] = React.useState(initialFilter);

  const handleFilterChange = (key: keyof typeof filter, value: string) => {
    setFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleClearFilters = () => {
    setFilter(initialFilter);
  };

  const [hasMounted, setHasMounted] = React.useState(false);
  const [dateRange, setDateRange] = React.useState<[Date | null, Date | null]>([null, null]);

  const handleDateRangeChange = (range: [Date | null, Date | null]) => {
    setDateRange(range);
  };

  React.useEffect(() => {
    setHasMounted(true);
  }, []);

  return {
    // state
    filter,
    dateRange,
    hasMounted,

    // function
    handleFilterChange,
    handleClearFilters,
    handleDateRangeChange,
  };
};
